import { FileViewerFileListItemStyled } from './styles/FileViewerFileListItemStyled'
import { useFileViewerContext } from '../../FileViewerContext'
import { type IFileData } from '@ui/blocks/File'
import { Media } from '@ui/elements/Media'

export interface IFileViewerFileListItemProps<FileType = IFileData> {
  file: FileType
  onClick: () => void
  isActive: boolean
}

export const FileViewerFileListItem = <FileType extends object = IFileData>({
  onClick,
  file,
  isActive,
}: IFileViewerFileListItemProps<FileType>) => {
  const { getFileData } = useFileViewerContext()

  return (
    <FileViewerFileListItemStyled isActive={isActive} onClick={onClick}>
      <Media
        as='div'
        src={getFileData(file).file || undefined}
        name={getFileData(file).name}
        fallbackSrc={getFileData(file).preview}
        href={undefined}
        shadow={false}
      />
    </FileViewerFileListItemStyled>
  )
}
